/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React from "react";
import ServicesLayout from "../../components/ServicesLayout";
import _ from "lodash";
import {
  addVisit,
  fetchEboiUser,
  fetchPrecints,
  fetchMapState,
  checkEpuapCertificate,
} from "../../lib/utils";
import EPUAPCertNotFound from "../ePUAPNotFound/ePUAPCertNotFound";
import NotFound from '../notFound/NotFound';

import EServices from "./EServices.js";
import CreatedEservice from "./CreatedEservice.js";
import DecyzjeWZ from "./DecyzjeWZ";
import UsuniecieDrzew from "./UsuniecieDrzew";

import SporzadzenieMPZP from "./SporzadzenieMPZP";
import ZezwolenieAlkohol from "./ZezwolenieAlkohol";
import ZmianaCeluPublicznego from "./ZmianaCeluPublicznego";
import ZmianaMPZP from "./ZmianaMPZP";
import UstalenieNumeruPorzadkowego from "./UstalenieNumeruPorzadkowego";
import OplataPlanistyczna from "./OplataPlanistyczna";
import DecyzjeULICP from "./DecyzjeULICP";
import DecyzjaSrodowiskowa from "./DecyzjaSrodowiskowa";
import ZaswiadczenieEMUIA from "./ZaswiadczenieEMUIA.js";
import ServiceWMSWFS from "./ServiceWMSWFS";
import InvestContact from "./InvestContact";
import InvestContactForm from "./InvestContactForm";
import ZmianaWarunkowZabudowy from "./ZmianaWarunkowZabudowy";
import ZmianaSUIKZP from "./ZmianaSUIKZP";
import PrzeniesienieSrodowiskowychUwarunkowan from "./PrzeniesienieSrodowiskowychUwarunkowan";
import LudnoscMiejscowosc from "./LudnoscMiejscowosc";
import LudnoscUlica from "./LudnoscUlica";
import OdpadyInfo from "./OdpadyInfo";
import DzierzawaNieruchomosci from "./DzierzawaNieruchomosci";
import OpiniaPodzialu from "./OpiniaPodzialu";
import ZaswiadczenieFormOchrony from "./ZaswiadczenieFormOchrony";
import WniosekPomnikPrzyrody from "./WniosekPomnikPrzyrody";
import UwagiProceduryPlanistycznej from "./UwagiProceduryPlanistycznej";
import SprzedazNieruchomosci from "./SprzedazNieruchomosci";
import ZgodnoscMPZP from "./ZgodnoscMPZP";
import WniosekUproszczonyWypis from "./WniosekUproszczonyWypis";
import ZgloszeniePOS from "./ZgloszeniePOS";
import PrzeniesienieDecyzjiOWarunkachZabudowy from "./PrzeniesienieDecyzjiOWarunkachZabudowy";
import LinkRedirector from "./LinkRedirector";
import WniosekMiejsceNaCmentarzu from "./WniosekMiejsceNaCmentarzu";
import PrzedlDzierBudGosp from "./PrzedlDzierBudGosp";
import PrzedDzierGrunty from "./PrzedDzierGrunty";
import DzierGruntRolnych from "./DzierGruntRolnych";
import WykrHipoteki from "./WykrHipoteki";
import PrzeniesienieCeluPublicznego from "./PrzeniesienieCeluPublicznego";
import UzgodnienieBudowyOgrodzenia from "./UzgodnienieBudowyOgrodzenia";
import ZwolnieniePasaDrogowego from "./ZwolnieniePasaDrogowego";
import NaliczenieOplatyRocznej from "./NaliczenieOplatyRocznej";
import WniosekUzytkownikaWieczystego from "./WniosekUzytkownikaWieczystego";
import ZajeciePasaDrogowego from "./ZajeciePasaDrogowego";
import PrzydzialLokaluMieszkalnego from "./PrzydzialLokaluMieszkalnego";
import SprzedazGruntuPodGaraz from "./SprzedazGruntuPodGaraz";
import SprzedazGruntuNaRzeczWUzytkownika from "./SprzedazGruntuNaRzeczWUzytkownika";
import ZmianaAdrDoKorespondencji from "./ZmianaAdrDoKorespondencji";
import NabycieNieruchomosciBezPrzetargu from "./NabycieNieruchomosciBezPrzetargu";
import ZbycieNieruchomosciWPrzetargu from "./ZbycieNieruchomosciWPrzetargu";
import OddanieNieruchomosci from "./OddanieNieruchomosci";
import RozgraniczenieNieruchomosci from "./RozgraniczenieNieruchomosci";
import DzierzawaGruntowRolnych from "./DzierzawaGruntowRolnych";
import PrzeksztalceniePrawaUzytkowania from "./PrzeksztalceniePrawaUzytkowania";
import WydanieDecyzjiWZ from "./WydanieDecyzjiWZ";
import WydanieDecyzjiULICP from "./WydanieDecyzjiULICP";
import PrzekroczenieTonazu from "./PrzekroczenieTonazu";
import ObciazanieNieruchomosci from "./ObciazanieNieruchomosci";
import OplataRoczna from "./OplataRoczna";
import UwagaMPZP from "./UwagaMPZP";
import DecyzjeWZiULICP from "./DecyzjeWZiULICP";
import ZgloszenieUsunieciaDrzew from "./ZgloszenieUsunieciaDrzew";
import WydanieNagranZMonitoringu from "./WydanieNagranZMonitoringu";
import ZbycieNieruchomosciKomunalnej from "./ZbycieNieruchomosciKomunalnej";
import RozwiazanieUmowyNieruchomosci from "./RozwiazanieUmowyNieruchomosci";
import PrzedluzenieUmowyNieruchomosci from "./PrzedluzenieUmowyNieruchomosci";
import UmowaNieruchomosci from "./UmowaNieruchomosci";
import Natura2000 from "./Natura2000";
import CzasoweZajeciePasa from "./CzasoweZajeciePasa";
import WykonanieZjazduZDrogi from "./WykonanieZjazduZDrogi";
import WydanieDecyzjiSrodowiskowej from "./WydanieDecyzjiSrodowiskowej";
import ZmianaWZULICP from "./ZmianaWZULICP";
import PrzeniesienieWZULICP from "./PrzeniesienieWZULICP";
import WniosekWZ from "./WniosekWZ";
import WniosekULICP from "./WniosekULICP";
import ZaswiadczenieOPrzeznaczeniu from "./ZaswiadczenieOPrzeznaczeniu";
import DzierzawaMiejscaGrzebalnego from "./DzierzawaMiejscaGrzebalnego";
import OplataZaDzierzaweMiejscaGrzebalnego from './OplataZaDzierzaweMiejscaGrzebalnego';
import UstNrPorz from './UstNrPorz';
import LoginWK from "./loginWK";
import LoginPZ from "./loginPZ";

const MainRoute = {
  path: "/",

  async action(req) {
    const list = {
      ZmianaMPZP,
      EServices,
      invest_contact: InvestContact,
      invest_contact_form: InvestContactForm,
      DecyzjeWZ,
      UsuniecieDrzew,
      SporzadzenieMPZP,
      ZezwolenieAlkohol,
      ZmianaCeluPublicznego,
      UstalenieNumeruPorzadkowego,
      OplataPlanistyczna,
      DecyzjeULICP,
      DecyzjaSrodowiskowa,
      ZaswiadczenieEMUIA,
      ServiceWMSWFS,
      ZmianaWarunkowZabudowy,
      ZmianaSUIKZP,
      PrzeniesienieDecyzjiOWarunkachZabudowy,
      PrzeniesienieSrodowiskowychUwarunkowan,
      LudnoscMiejscowosc,
      LudnoscUlica,
      OdpadyInfo,
      DzierzawaNieruchomosci,
      OpiniaPodzialu,
      ZaswiadczenieFormOchrony,
      WniosekPomnikPrzyrody,
      UwagiProceduryPlanistycznej,
      SprzedazNieruchomosci,
      ZgodnoscMPZP,
      WniosekUproszczonyWypis,
      ZgloszeniePOS,
      LinkRedirector,
      WniosekMiejsceNaCmentarzu,
      PrzedlDzierBudGosp,
      PrzedDzierGrunty,
      DzierGruntRolnych,
      WykrHipoteki,
      PrzeniesienieCeluPublicznego,
      UzgodnienieBudowyOgrodzenia,
      ZwolnieniePasaDrogowego,
      NaliczenieOplatyRocznej,
      WniosekUzytkownikaWieczystego,
      ZajeciePasaDrogowego,
      PrzydzialLokaluMieszkalnego,
      SprzedazGruntuPodGaraz,
      SprzedazGruntuNaRzeczWUzytkownika,
      ZmianaAdrDoKorespondencji,
      NabycieNieruchomosciBezPrzetargu,
      ZbycieNieruchomosciWPrzetargu,
      OddanieNieruchomosci,
      RozgraniczenieNieruchomosci,
      DzierzawaGruntowRolnych,
      PrzeksztalceniePrawaUzytkowania,
      WydanieDecyzjiWZ,
      WydanieDecyzjiULICP,
      PrzekroczenieTonazu,
      ObciazanieNieruchomosci,
      OplataRoczna,
      UwagaMPZP,
      DecyzjeWZiULICP,
      ZgloszenieUsunieciaDrzew,
      WydanieNagranZMonitoringu,
      ZbycieNieruchomosciKomunalnej,
      RozwiazanieUmowyNieruchomosci,
      PrzedluzenieUmowyNieruchomosci,
      UmowaNieruchomosci,
      Natura2000,
      CzasoweZajeciePasa,
      WykonanieZjazduZDrogi,
      WydanieDecyzjiSrodowiskowej,
      ZmianaWZULICP,
      PrzeniesienieWZULICP,
      WniosekWZ,
      WniosekULICP,
      ZaswiadczenieOPrzeznaczeniu,
      DzierzawaMiejscaGrzebalnego,
      OplataZaDzierzaweMiejscaGrzebalnego,
      UstNrPorz,
      CreatedEservice,
    };

    const { query, store } = req;
    const state = store.getState();
    const service = state.district.eservices[query.serviceType];
    const { component, ...eservice } = service;
    const Component = list[component];
    const district = _.find(
      state.district.districts,
      (v) => v.teryt == query.district
    );

    if (!district.showOnList) {
      return {
        title: 'Nie znaleziono zasobu',
        component: <ServicesLayout><NotFound title={''} /></ServicesLayout>,
        status: 404,
      };
    }

    const isDisabled =
      district.disabledServices.indexOf(query.serviceType) >= 0;
    let props = { eservice };

    if (!district.wkLogin) {
      const certValid = await checkEpuapCertificate(district.teryt);

      // wyjatki sprawdzania certow dla gmin które nie mają certu ale ma sie odbyc szkolenie w urzedzie
      // GMINA TESTOWA
      const terytList = [999999];
      if (eservice.requiresEPUAP && !certValid && !terytList.includes(district.teryt)) {
        return {
          title: `${eservice.title} - Formularz - ${district ? district.name : ''} - ipodlaskie.pl`,
          component: (
            <ServicesLayout prefix={district ? district.prefix : null}>
              <EPUAPCertNotFound title={""} />
            </ServicesLayout>
          ),
          description: `${eservice.title} - Formularz - ${district ? district.name : ''} - ipodlaskie.pl`,
        };
      }
    }

    const mapState = await fetchMapState(query.district);

    // If service requires user info then fetch it
    if (eservice.requiresUserInfo) {
      if (state.user) {
        if (
          (!state.user.isConnectedToPZ || !state.user.IdZaufanegoProfilu) &&
          !state.user.isWkProfile
        ) {
          return { redirect: "/connectPZ" };
        }
        props = { ...props, user: { ...state.user, userType: "local" } };
      }
      // else if (Object.keys(query).indexOf('customerId') >= 0) {
      //   const user = await fetchEboiUser(query.customerId, query.district);
      //   if (!user) {
      //     const redirect = `/logowanieSAML?${Object.keys(req.query).map(key => `${key}=${req.query[key]}`).join('&')}&redirectURL=${req.route.path}`;
      //     return { redirect };
      //   }
      //   props = { ...props, user: { ...user, userType: 'eboi' } };
      // }
      else {
        if (!process.env.BROWSER) {
          return {
            title: "Wczytywanie",
            component: <LoginPZ wkLogin={district.wkLogin} />,
            description: "Widok wczytywania kontentu.",
          };
        } else {
          if (district.wkLogin) {
            return {
              title: "Logowanie wk",
              component: <LoginWK prefix={district.prefix} />,
              description: "Formularz z kontentem saml",
            };
          }
          window.location.replace(
            `${window.location.origin}/logowanieSAML?redirectUrl=${window.location.href}`,
          );
          return {
            title: `${eservice.title} - Formularz - ${district ? district.name : ''} - ipodlaskie.pl`,
            component: (
              <ServicesLayout
                prefix={district ? district.prefix : null}
                officeName={district ? district.name : 'Urząd Gminy Ropczyce'}
              >
                <div>Wczytywanie...</div>
              </ServicesLayout>
            ),
            description: eservice.title,
          };
        }
        // return { redirect: '/logowanieSAML' };
      }
    }

    if (query.redirectURL) {
      return { redirect: query.redirectURL };
    }

    // If service requires map with precints then fetch them
    if (eservice.enablePrecints) {
      const precints = await fetchPrecints(query.district);
      props = { ...props, precints };
    }

    props.eservice.signWithEPUAP = false;
    props.eservice.confirmText = null;

    return {
      title: `${eservice.title} - Formularz - ${district ? district.name : ''} - ipodlaskie.pl`,
      component: (
        <ServicesLayout
          prefix={district ? district.prefix : null}
          officeName={district ? district.name : 'Urząd Gminy Ropczyce'}
        >
          <Component
            prefix={district.prefix}
            serviceInfo={props}
            district={query.district}
            query={query}
            isDisabled={isDisabled}
            {...mapState}
          />
        </ServicesLayout>
      ),
      description: eservice.title,
    };
  },
};

export default {
  path: "/eservices",
  children: [
    MainRoute,
    require("../eserviceSummary").default,
    require("../paymentStatus").default,
  ],
};



// WEBPACK FOOTER //
// src/routes/eservices/index.js